import React, { useMemo } from 'react';
import s from './chat-list.module.scss';
import classNames from 'classnames';
import { formatChatLastDate, isInteractiveMessage, getMessagePreview } from '@entities/messanger';
import { getAttachmentLabel } from '@utils/lib/isImage';

export const ChatCard = React.memo(({ chat, isActive, profileId, onClick }) => {
  const participant = chat?.participants?.[0];

  const avatarSrc = useMemo(() => {
    if (participant?.role === 'service') return '/logo192.png';
    if (participant?.avatar) {
      return process.env.REACT_APP_STORAGE_URL + participant.avatar;
    }
    return process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png';
  }, [participant?.role, participant?.avatar]);

  const isUnread = useMemo(() => {
    if (!chat?.last_message) return false;
    return (
      chat.last_message.sender_id !== profileId && !chat.last_message.is_read
    );
  }, [chat?.last_message, profileId]);

  const statusText = useMemo(() => {
    if (isInteractiveMessage(chat?.last_message)) {
      return getMessagePreview(chat.last_message);
    }
    if (chat?.last_message?.data) {
      return chat.last_message.data.slice(0, 20);
    }
    const attachment =
      chat?.last_message?.attachments?.[0] || chat?.last_message?.attachment;
    if (attachment) {
      return getAttachmentLabel(attachment);
    }
    if (chat?.last_message) {
      return 'Вложение';
    }
    return 'Нет сообщений';
  }, [chat?.last_message]);

  const lastDate = useMemo(
    () => formatChatLastDate(chat?.last_message?.timestamp),
    [chat?.last_message?.timestamp]
  );

  return (
    <div
      className={classNames(s.chatCard, isActive && s.active)}
      onClick={onClick}
    >
      <div
        className={classNames(
          s.avatarWrapper,
          participant?.online && s.online
        )}
      >
        <div className={s.avatar}>
          <img src={avatarSrc} alt="" />
        </div>
      </div>
      <div className={s.chatCardContent}>
        <div className={s.jcsb}>
          <div className={s.name}>{participant?.name}</div>
          <div className={s.date}>{lastDate}</div>
        </div>
        <div className={s.jcsb}>
          <div className={s.status}>{statusText}</div>
          {isUnread && <div className={s.unread}></div>}
        </div>
      </div>
    </div>
  );
});
